// src/constants/workspaceTypes.js

// Canonical list of workspace types used across the app.
// Values should match what your backend expects for booth "type"/"workspace_type".
export const WORKSPACE_TYPES = [
  { label: "Private Suite", value: "suite" },
  { label: "Chair / Station", value: "chair" },
  { label: "Room", value: "room" },
  { label: "Open Floor", value: "open" },
];
